import { render, staticRenderFns } from "./ListResources.vue?vue&type=template&id=4d695f49&scoped=true"
import script from "./ListResources.vue?vue&type=script&lang=js"
export * from "./ListResources.vue?vue&type=script&lang=js"
import style0 from "./ListResources.vue?vue&type=style&index=0&id=4d695f49&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d695f49",
  null
  
)

export default component.exports